<script lang="ts" setup>
import { hasSlotContent } from '../../utils';
import { ObPane } from '../pane';
import type { Elevation } from '../../shared/types';
interface ObPaneProps {
  elevation?: Elevation;
  selected?: boolean;
  hoverable?: boolean;
}
const props = withDefaults(defineProps<ObPaneProps>(), {
  elevation: '0',
  selected: false,
  hoverable: false,
});
</script>

<template>
  <ObPane
    :class="$style.root"
    :selected="props.selected"
    :hoverable="props.hoverable"
    :elevation="elevation"
  >
    <div v-if="hasSlotContent($slots.header)" :class="$style.header">
      <slot name="header" />
    </div>
    <div :class="$style.body">
      <slot />
    </div>
    <div v-if="hasSlotContent($slots.footer)" :class="$style.footer">
      <slot name="footer" />
    </div>
  </ObPane>
</template>

<style lang="scss" module>
@use '../../styles/colors';

.root {
  overflow: hidden;
}

.header,
.footer {
  padding: 12px 24px;
}

.header {
  background: #f8f7fe;
}

.body {
  padding: 24px;
}

.footer {
  border-top: 1px solid colors.$surface-6;
}
</style>
